//TODO: remove any
const RenderSubSection = (subRouteKeywords: any, subSections: any) => {
    let subSection: any[] = [];

    Object.keys(subRouteKeywords).forEach((keyword: any) => {
        // ['create','list','search','update','upload']

        subRouteKeywords[keyword]?.include_only?.forEach((item: any) => {
            if (
                subRouteKeywords["list"]?.include_only?.includes(item) &&
                subRouteKeywords["view"]?.include_only?.includes(item)
            ) {
                subSections[item][keyword].isView = true;
            }
            subSection.push(
                //@ts-ignore
                subSections[item][keyword]
            );
        });
    });
    return subSection;
};

export default RenderSubSection;
